module.exports = __webpack_public_path__ + "static/media/BNPP_BL_Q.c66e96b0.png";